import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import UserNotification from "../../models/notificiations/notification";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class UserNotificationsService {
  private readonly url: string;

  constructor(private http: HttpClient, private config: ConfigurationService) {
    if (this.config.getConfig().isLocal) {
      this.url = this.config.getConfig().localEndpoints.userNotifications;
    } else {
      this.url = this.config.getConfig().apiUrl + "/user-notifications";
    }
  }

  public configureWatch(
    keyField: string,
    eventTypes: string[]
  ): Observable<void> {
    return this.http.post<void>(this.url + "/", {
      keyField: keyField.toString(),
      eventTypes: eventTypes,
    });
  }

  public getNotifications(): Observable<UserNotification[]> {
    return this.http.get<UserNotification[]>(this.url + "/");
  }
}



// WEBPACK FOOTER //
// ./src/providers/users-service/user-notifications.service.ts